import { render, staticRenderFns } from "./AppGeneral.vue?vue&type=template&id=203d616b&"
import script from "./AppGeneral.vue?vue&type=script&lang=js&"
export * from "./AppGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports